<template>
  <div class="emoji-picker">
    <div class="emojis">
      <span
          v-for="(emoji, index) in emojis"
          :key="index"
          @click="selectEmoji(emoji)"
      >
        {{ emoji }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomEmojiPicker',
  props: {
    emojis: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    selectEmoji (emoji) {
      this.$emit('select', emoji)
    }
  }
}
</script>

<style scoped lang="sass">
.emoji-picker
  position: relative
  display: inline-block

.emoji-picker .emojis
  display: flex
  flex-wrap: wrap
  max-width: 15rem
  max-height: 10rem
  overflow: auto
  border: 1px solid #ccc
  border-radius: 5px
  padding: 0.5rem
  background: #fff
  box-shadow: 1px 1px 8px #c7dbe6

.emoji-picker .emojis span
  padding: 0.3rem
  cursor: pointer
  border-radius: 3px

.emoji-picker .emojis span:hover
  background: #ececec
  cursor: pointer
</style>
